import React, { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { MobileContext } from '@wix/da-react-context/pkg/MobileContext';
import { Props as IconProps, IconSize } from '@wix/da-ds/pkg/Icons/IconWrap';
import NetworkBarItem, { type NetworkBarItemProps } from '../NetworkBarItem';
import {
  BiData,
  Networkbar3DotsOpenBiEvent,
  NetworkbarNavClickBiEvent,
} from '@wix/da-bi/pkg/events';

export interface Props
  extends Omit<
    NetworkBarItemProps,
    | 'children'
    | 'icon'
    | 'biData'
    | 'menuBiData'
    | 'tooltipContent'
    | 'aria-label'
  > {
  label: string;
  icon?: React.ComponentType<IconProps>;
  iconElement?: React.ReactNode;
  url: string;
}

const NetworkBarLink: React.FC<Props> = ({
  label,
  icon: Icon,
  iconElement,
  url,
  hasNewContent,
  showTooltip,
  isCollapsed,
  ...rest
}) => {
  const { t } = useTranslation();
  const isMobile = useContext(MobileContext);
  return (
    <NetworkBarItem
      url={url}
      tooltipContent={t(`networkBar.navItems.${label}.tooltip`)}
      aria-label={t(`networkBar.navItems.${label}`)}
      icon={
        iconElement
          ? iconElement
          : Icon && <Icon disableDefaultColors size={IconSize.MEDIUM} />
      }
      biData={BiData<NetworkbarNavClickBiEvent>({
        evid: 160,
        sectionname: label,
        indicator: hasNewContent ? 1 : 0,
        is_expanded: isCollapsed ? 0 : 1,
      })}
      menuBiData={BiData<Networkbar3DotsOpenBiEvent>({
        evid: 162,
        sectionname: label,
        indicator: hasNewContent ? 1 : 0,
      })}
      hasNewContent={hasNewContent}
      isCollapsed={isCollapsed}
      isTaller={isMobile}
      {...rest}
    >
      {t(`networkBar.navItems.${label}`)}
    </NetworkBarItem>
  );
};
NetworkBarLink.displayName = 'NetworkBarLink';

export default NetworkBarLink;
